
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { Crown } from "lucide-react";

interface MembershipCardProps {
  tier: string;
}

export function MembershipCard({ tier }: MembershipCardProps) {
  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full">
      <CardHeader className="p-4">
        <CardTitle className="text-white text-lg">Membership</CardTitle>
        <CardDescription className="text-white/70 text-xs">
          Your current membership tier
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-yellow-500/10 flex items-center justify-center">
            <Crown className="h-5 w-5 text-yellow-500" />
          </div>
          <div>
            <div className="text-lg font-semibold text-white">{tier}</div>
            <div className="text-xs text-white/70">Active membership</div>
          </div>
        </div>
        <div className="bg-white/5 w-full mt-3 p-3 rounded-lg">
          <p className="text-white/80 text-xs">
            {tier === 'Beta' ? 'You have early access to all features during our beta period!' : 'Enjoy exclusive features with your premium membership!'}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
